import { useState, useEffect, useRef } from "react";
import { Form, Row, Col } from 'react-bootstrap'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

function PhoneNumber(props) {

    const [checkBox, setCheckBox] = useState([]);
    const [mobileNumberValue, setMobileNumberValue] = useState('')
    const [phoneNumberValue, setPhoneNumberValue] = useState('')

    const isReadonly = props.isReadonly ? {disabled: true} : {}
    
    const phoneInputRef = useRef(null);
    // Get only the alpha2 
    let defaultCountryCode = props.global.defaultCountryCode
    defaultCountryCode = Object.values(defaultCountryCode.map(item => (
        item.alpha2.toLowerCase()
    )));
    
    const [data, setData] = useState({ 
        mobile: "",
        mobileField: "",
        phone_number: "",
        phoneNumberField: "",
        show_mobile_number: "",
        show_phone_number: "",
        mobileNumberToSave: "",
        phoneNumberToSave: "",
        mobileCountryCodeAlpha2: "",
        phoneNumberCountryCodeAlpha2: ""
    })

    const handleChangeNumber = (value, country, e, formattedValue) => {
        let number = value.slice(country.dialCode.length);
        // Set value of field
        switch (phoneInputRef.current.name) {
            case "mobile_number":
                props.handleChange(country.countryCode,"mobileCountryCodeAlpha2")
                props.handleChange(number,'mobileNumberToSave')
                break;
            case "phone_number":
                props.handleChange(country.countryCode,"phoneNumberCountryCodeAlpha2")
                props.handleChange(number,'phoneNumberToSave')
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        setData({ 
            mobile: props.data.mobile !== null ? props.data.mobile : "",
            mobileField: props.data.mobileField !== null ? props.data.mobileField : "",
            phone_number: props.data.phone_number !== null ? props.data.phone_number : "",
            phoneNumberField: props.data.phoneNumberField !== null ? props.data.phoneNumberField : "",
            mobileNumberToSave: props.data.mobileNumberToSave !== null ? props.data.mobileNumberToSave : "",
            phoneNumberToSave: props.data.phoneNumberToSave !== null ? props.data.phoneNumberToSave : "",
            mobileCountryCodeAlpha2: props.data.mobileCountryCodeAlpha2 !== null ? props.data.mobileCountryCodeAlpha2 : "",
            phoneNumberCountryCodeAlpha2: props.data.phoneNumberCountryCodeAlpha2 !== null ? props.data.phoneNumberCountryCodeAlpha2 : "",
            show_mobile_number: 1,//Todo: should be dynamic
            show_phone_number: 0 //Todo: should be dynamic
        })
    }, [props.data.mobile_number, props.data.phone_number]);


    useEffect(() => {
        if (props.cancelClicked) {
            // Reset the cancelClicked state to false after performing the actions
            setMobileNumberValue('');
            setPhoneNumberValue('');
            props.setCancelClicked(false);
        }
        else
        {
            setMobileNumberValue(data.mobileField);
            setPhoneNumberValue(data.phoneNumberField);
        }

        
        let checkBox = [
            { type:"Mobile Phone", id: "mobilePhone", label: "Mobile Phone", number: data.mobileField, defaultNumber: props.defaultNumber.mobile, name:"mobile_number", countryCode: data.mobileCountryCodeAlpha2 },
            { type:"Home Phone", id: "homePhone", label: "Home Phone", number: data.phoneNumberField, defaultNumber: props.defaultNumber.phone_number, name:"phone_number",  countryCode: data.phoneNumberCountryCodeAlpha2  },
            // { type:"Work Phone", id: "workPhone", label: "Work Phone", number: "555-555-555" },
            // { type:"Other", id: "otherPhone", label: "Other", number: "555-555-555" }
        ];
        setCheckBox(
            checkBox.map(d => {
                return {
                    select:false, 
                    type:d.type, 
                    id:d.id, 
                    label:d.label,
                    number:d.number,
                    name:d.name,
                };
            })
        );
    }, [data, props.cancelClicked, props.save]);

    function selectOnlyThis(e,name) {

        for (var i = 0;i < 2; i++)
        {
            document.getElementById('myCheckbox'+i).checked = false;
        }

        document.getElementById(name).checked = true;
    }

    return (            
        <>
            {checkBox.map((d, i) => (
                <Form.Group as={Row} key={i} className="mb-4">
                    <Form.Label column md="3" className="text-md-right">{d.type}</Form.Label>
                    <Col md="7">
                        <Row>
                            {/* <Col lg="7"> */}
                                {/* <Form.Control type="text" className="rounded-0 sectionPhone" defaultValue={d.number} /> */}
                                {/*<input type="text" className="rounded-0 sectionPhone form-control" name={d.name} defaultValue={d.number} onChange={props.handleChange} readOnly={props.isReadonly}></input>*/}
                                <PhoneInput
                                  country={d.name == "mobile_number" ? data.mobileCountryCodeAlpha2 : data.phoneNumberCountryCodeAlpha2}
                                  value={d.name == "mobile_number" ? mobileNumberValue : phoneNumberValue}
                                  onlyCountries={defaultCountryCode}
                                  preferredCountries={['us','ca']}
                                  defaultMask={'...-...-....'}
                                  alwaysDefaultMask={'true'}
                                  autoFormat={true}
                                  countryCodeEditable={false}
                                  dropdownClass={isReadonly.disabled ? "disabled-dropdown" : ""}
                                  enableSearch={true}
                                  inputName={d.name}
                                  disabled={isReadonly.disabled ? true : false}
                                  disableCountryGuess={true}
                                  inputProps={{
                                    name: d.name,
                                    required: true, 
                                    autoFocus: true,
                                    ref: phoneInputRef,
                                  }}
                                  inputStyle={{
                                    backgroundColor: isReadonly.disabled ? '#e9ecef' : '#fff',
                                  }}
                                  onChange={handleChangeNumber}
                                />
                            {/* </Col> */}
                            {/* <Col lg="5"> */}
                                {/* <Form.Check type="checkbox" className="custom-control custom-checkbox pt-1" id={'myCheckbox'+i}>
                                    <Form.Check.Input type="checkbox" checked={data && data.show_mobile_number == 1 && d.name == "mobile_number"? true : (data && data.show_phone_number==1 && d.name == "phone_number" ? true : false)} name={'show_'+d.name} onClick={(e)=>selectOnlyThis(e,'myCheckbox'+i)} className="custom-control-input" disabled={props.isReadonly}/>
                                    <Form.Check.Label className="custom-control-label">Show this number</Form.Check.Label>
                                </Form.Check> */}
                            {/* </Col> */}
                        </Row>
                    </Col>

                </Form.Group>
            ))}
            <style>
                {`
                .disabled-dropdown{
                    pointer-events: none;
                    opacity: 0;
                }`}
            </style>
        </>           
    );
}

export default PhoneNumber;
